/**
 * @file Чтение и удаление серверной сессии.
 *
 * Все способы входа и список хранилищ читают пользователя одинаково.
 * Данные проверяются до публикации в Context; браузерное хранилище не используется.
 */
import type { CustomerInfo } from '../../context/useCustomer'
import { withAbort } from '../../services/abort.ts'
import { makeRequestWithRetry } from '../../services/request.ts'
import { parseCustomerInfo } from './sessionData.ts'
import { SignInError } from './signInError.ts'

export async function fetchSession(signal: AbortSignal): Promise<CustomerInfo> {
    signal.throwIfAborted()

    const response = await withAbort(
        fetch('/user-api/customer/session', {
            credentials: 'same-origin',
            cache: 'no-store',
            redirect: 'error',
            signal,
        }),
        signal,
    )
    if (!response.ok) throw new SignInError('invalidSession')

    try {
        const data: unknown = await withAbort(response.json(), signal)
        signal.throwIfAborted()

        return parseCustomerInfo(data)
    } catch (error) {
        signal.throwIfAborted()
        if (error instanceof SyntaxError)
            throw new SignInError('invalidSession')

        throw error
    }
}

export async function deleteSession(signal: AbortSignal): Promise<void> {
    const response = await makeRequestWithRetry({
        path: '/user-api/customer/session',
        opts: { method: 'DELETE', credentials: 'same-origin', signal },
    })
    if (response.status !== 204) throw new Error('Session deletion failed')
}
